export default __webpack_public_path__ + "static/media/zoho.35d949eb.svg";